var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_11014",
    x: 0,
    y: 0,
    width: 36,
    height: 33,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9045",
    "data-name": "Group 9045",
    transform: "translate(-2109.2 -3622.79)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2109.2, 3622.79)",
    filter: "url(#Path_11014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11014-2",
    "data-name": "Path 11014",
    d: "M-1820,4321.79a2,2,0,0,1-2-2v-11a2,2,0,0,1,2-2h14a2,2,0,0,1,2,2v11a2,2,0,0,1-2,2Zm-1.2-12.518v8.032l4.078-2.965c.025-.019.05-.037.076-.054l.009-.006.011-.007.019-.012h0a1.668,1.668,0,0,1,.9-.261,1.673,1.673,0,0,1,1.133.44l2.718,2.373a1.76,1.76,0,0,0,1.136.417,1.76,1.76,0,0,0,.891-.244l5.561-3.262v-4.449a1.484,1.484,0,0,0-1.483-1.482h-13.569A1.484,1.484,0,0,0-1821.2,4309.272Zm8.3,2.571a1.582,1.582,0,0,1,1.582-1.582,1.582,1.582,0,0,1,1.581,1.582,1.582,1.582,0,0,1-1.581,1.583A1.582,1.582,0,0,1-1812.9,4311.843Z",
    transform: "translate(1831 -4300.79)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImage);
export default __webpack_public_path__ + "static/media/file-image.54d14ccd.svg";
export { ForwardRef as ReactComponent };